import { writable } from 'svelte/store';
export const confirmState = writable(null);
